<template>
  <router-link class="quality-item" :to="`/detail/${topic.englishName}/${data.id}`">
    <!-- <YorkbbsImage
      width="100%"
      height="210px"
      borderRadius="4px"
      animation
      :src="data.imageList[0] | webpFormat(300)"
    ></YorkbbsImage> -->
    <img :src="data.imageList[0] | webpFormat(300)" alt="" class="quality-img">
    <div class="quality-desc">
      <div class="quality-title e">{{ data.title }}</div>
    </div>
    <img class="quality-label" :src="require('@/assets/images/car/label_quality.png')" />
  </router-link>
</template>
<script>
export default {
  name: 'ItemQuality',
  props: { data: Object },
  created(){
    console.log('头条banner-------->',this.data.imageList)
  },
  computed: {
    topic() {
      return this.data.property.topics[0] || {};
    },
  },
};
</script>
<style lang="scss" scoped>
.quality-item {
  display: block;
  width: 280px;
  position: relative;
}
.quality-desc {
  padding: 15px;
  border-color: #eee;
  border-width: 0 1px 1px;
  border-style: solid;
  border-radius: 0 0 4px 4px;
}
.quality-title {
  font-size: 18px;
  line-height: 25px;
  color: var(--text-color-3);
  &:hover {
    color: var(--primary-color);
  }
}
.quality-label {
  width: 98px;
  height: 34px;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
}
.quality-img{display: block; width:100%; height: 210px; border-radius:4px 4px 0 0; object-fit: cover;}
</style>
